import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";

export function Footer() {
  const [guides, setGuides] = useState([]);
  useEffect(() => {
    api.get("/guides").then((r) => setGuides(r.data.slice(0, 5))).catch(() => {});
  }, []);

  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-ink pb-24 sm:pb-0">
      <div className="mx-auto grid max-w-[1600px] gap-12 px-5 py-16 sm:grid-cols-2 sm:px-10 lg:grid-cols-4">
        <div>
          <img src="/assets/logo-wordmark.webp" alt="SWAPA™" className="h-7 w-auto" />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-zinc-500">
            The Urban Lifestyle Icon. Quadriciclo elettrico L6e progettato per la città. Non adattato ad essa.
          </p>
          <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-600">Milano — Italia</p>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">Esplora</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link to="/tecnologia" data-testid="footer-link-tecnologia" className="text-zinc-400 transition-colors hover:text-white">Tecnologia ONE+1™, F-TOUCH™, MONOQ™</Link></li>
            <li><Link to="/test-drive" data-testid="footer-link-testdrive" className="text-zinc-400 transition-colors hover:text-white">Prenota un test drive</Link></li>
            <li><Link to="/network" data-testid="footer-link-network" className="text-zinc-400 transition-colors hover:text-white">Rete SWAPA in Italia</Link></li>
            <li><Link to="/preordina" data-testid="footer-link-preorder" className="text-zinc-400 transition-colors hover:text-white">Pre-ordina — €200</Link></li>
            <li><Link to="/guide" data-testid="footer-link-guide" className="text-zinc-400 transition-colors hover:text-white">Guide alla microcar elettrica</Link></li>
            <li><Link to="/hospitality" data-testid="footer-link-hospitality" className="text-zinc-400 transition-colors hover:text-white">SWAPA Hospitality — mobilità elettrica per hotel e resort</Link></li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">Guide</p>
          <ul className="mt-5 space-y-3 text-sm">
            {guides.map((g) => (
              <li key={g.slug}>
                <Link to={`/guide/${g.slug}`} data-testid={`footer-guide-${g.slug}`} className="text-zinc-400 transition-colors hover:text-white">
                  {g.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">Contatti</p>
          <ul className="mt-5 space-y-3 text-sm text-zinc-400">
            <li className="font-semibold text-zinc-300">SWAPA Italia — FILANTE Motors srl</li>
            <li>Via Isaac Newton 9<br />20016 Pero — Milano</li>
            <li><a href="mailto:info@swapa.it" data-testid="footer-email" className="transition-colors hover:text-white">info@swapa.it</a></li>
            <li><a href="tel:800826557" data-testid="footer-phone" className="transition-colors hover:text-white">800 826 557</a></li>
            <li className="font-mono text-xs tracking-wider text-zinc-500">VAT 11173950962</li>
          </ul>
          <div className="mt-8 space-y-2 text-xs text-zinc-600">
            <Link to="/privacy" data-testid="footer-link-privacy" className="block transition-colors hover:text-zinc-300">Privacy e note legali</Link>
            <Link to="/recesso" data-testid="footer-link-recesso" className="block transition-colors hover:text-zinc-300">Recedere dal contratto qui</Link>
            <p>Contenuti contrattuali in fase di definizione.</p>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="mx-auto flex max-w-[1600px] flex-col gap-2 px-5 py-6 font-mono text-[10px] uppercase tracking-[0.22em] text-zinc-600 sm:flex-row sm:items-center sm:justify-between sm:px-10">
          <span>© 2026 SWAPA™ — Tutti i diritti riservati</span>
          <span>Designed for the city. Not adapted to it.</span>
        </div>
      </div>
    </footer>
  );
}
